import parseBarcodeNumber from "./parseBarcodeNumber"

export default (barcodes, barcode2) => {
    if (!barcodes || !barcode2) return false
    
    const parseds1 = barcodes.map(item => parseBarcodeNumber(item).number)
    const parsed2 = parseBarcodeNumber(barcode2)
    if (!parseds1 || !parsed2) return false

    return parseds1.includes(parsed2.number)
}